/**
 *
 * @param {jQuery} $elements
 * @param {object} cssProps
 */
export function view_setCssPropsForElement($elements, cssProps){
  $elements.css(cssProps);
}